<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Lista de Consejos</h4>
          </template>
          <template v-slot:headerAction>
            <b-button
              v-user-can="'crear consejos'"
              variant="primary"
              @click="showModal('add', { title: null, date: null, url: null })"
            >
              Agregar
            </b-button>
          </template>
          <template v-slot:body>
            <DataTable
              v-if="tips"
              :data="tips"
              :columns="columns"
              :fields-search="['title']"
            >
              <template #rows="{ row, rowIndex }">
                <tr>
                  <th scope="row">{{ rowIndex + 1 }}</th>
                  <td>
                    {{ row.title }}
                  </td>
                  <td>
                    <a :href="row.url" target="_blank">Ver Vídeo</a>
                  </td>
                  <td>
                    {{ row.date_format }}
                  </td>
                  <td>
                    <b-button-group>
                      <b-button
                        v-user-can="'actualizar consejos'"
                        variant="warning"
                        size="sm"
                        @click="showModal('edit', row)"
                      >
                        <i class="ri-ball-pen-fill m-0"></i>
                      </b-button>
                      <b-button
                        v-user-can="'eliminar consejos'"
                        variant="danger"
                        size="sm"
                        @click="destroy(row.id)"
                      >
                        <i class="ri-delete-bin-line m-0"></i>
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </template>
            </DataTable>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <ModalForm @getData="getData" :type="type" :data="data" />
  </b-container>
</template>

<script>
import { Toast } from './../../../mixins/toast'
import { xray } from '../../../config/pluginInit'
import api from './../../../services/api'
import DataTable from './../../../components/DataTable.vue'
import ModalForm from './ModalForm.vue'
import Swal from 'sweetalert2'

export default {
  components: {
    ModalForm,
    DataTable
  },
  data () {
    return {
      data: {},
      type: 'add',
      tips: [],
      columns: [
        {
          name: 'Título',
          field: 'title',
          sort: ''
        },
        {
          name: 'URL',
          field: 'url',
          sort: ''
        },
        {
          name: 'Fecha',
          field: 'date_format',
          sort: ''
        }
      ]
    }
  },
  mounted () {
    xray.index()
    this.getData()
  },
  methods: {
    async getData () {
      try {
        const { data } = await api.get('/tips')
        this.tips = data.data
      } catch (error) {
        Toast.fire({
          icon: 'error',
          title: 'Error'
        })
      }
    },
    showModal (type, data) {
      this.data = data
      this.type = type
      this.$bvModal.show('modal-form')
    },
    destroy (id) {
      Swal.fire({
        icon: 'warning',
        title: 'Seguro de eliminar',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          api
            .delete(`/tips/${id}`)
            .then((res) => {
              if (res.status === 200) {
                Toast.fire({
                  icon: 'success',
                  title: 'Eliminado correctamente'
                })
                this.getData()
              }
            })
            .catch((error) => {
              Toast.fire({
                icon: 'error',
                title: error.message
              })
            })
        }
      })
    }
  }
}
</script>
